module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/db-1920@2x-fd6a617f8f19dee23fed96ceec1f1c0d.webp";